'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component2 = require('./Component');

var _Component3 = _interopRequireDefault(_Component2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Component) {
	_inherits(Container, _Component);

	function Container(props, context, component) {
		_classCallCheck(this, Container);

		var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props, context));

		if (_this.loadData && !component) {
			console.warn("You need to specify the component used for rendering");
		}
		_this.component = component;
		_this._bind('retry');
		return _this;
	}

	_createClass(Container, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			_get(Container.prototype.__proto__ || Object.getPrototypeOf(Container.prototype), 'componentDidMount', this) && _get(Container.prototype.__proto__ || Object.getPrototypeOf(Container.prototype), 'componentDidMount', this).call(this);
			this.fetchData(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (this.props.params !== nextProps.params) {
				this.fetchData(nextProps);
			} else if (!this.props.missingData && nextProps.missingData) {
				this.fetchData(nextProps);
			} else if (!this.props.didInvalidate && nextProps.didInvalidate) {
				this.fetchData(nextProps);
			}
		}
	}, {
		key: 'fetchData',
		value: function fetchData(props) {
			this.loadData && this.loadData(props);
		}
	}, {
		key: 'retry',
		value: function retry() {
			this.fetchData(this.props);
		}
	}, {
		key: 'transitionTo',
		value: function transitionTo(route, notMounted) {
			if (notMounted) {
				this.preMountTransition = true;
			}
			_get(Container.prototype.__proto__ || Object.getPrototypeOf(Container.prototype), 'transitionTo', this).call(this, route);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props;
			var hasError = _props.hasError;
			var isFetching = _props.isFetching;
			var missingData = _props.missingData;
			var didInvalidate = _props.didInvalidate;


			if (hasError) {
				return this.renderError();
			} else if (isFetching && !didInvalidate || missingData || this.preMountTransition) {
				return this.renderLoading();
			}
			return this.renderComponent();
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			var viewProps = this.getViewProps && this.getViewProps();
			return _react2.default.createElement(this.component, _extends({
				loading: true
			}, viewProps));
		}
	}, {
		key: 'renderError',
		value: function renderError() {
			var viewProps = this.getViewProps && this.getViewProps();
			return _react2.default.createElement(this.component, _extends({
				error: true, retry: this.retry
			}, viewProps));
		}
	}]);

	return Container;
}(_Component3.default);

//TODO: Make dispatch isRequired (needs all handlers to be "connected")


exports.default = Container;
Container.propTypes = {
	isFetching: _react.PropTypes.bool,
	missingData: _react.PropTypes.bool,
	hasError: _react.PropTypes.bool,
	didInvalidate: _react.PropTypes.bool,
	lastUpdated: _react.PropTypes.object,
	dispatch: _react.PropTypes.func
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-component-web/dist/Container.js
 ** module id = 254
 ** module chunks = 0
 **/